var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNavbarVideo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17975",
    "data-name": "Group 17975",
    transform: "translate(-355 -63)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44270",
    "data-name": "Path 44270",
    d: "M15,5l3.781-3.025A.75.75,0,0,1,20,2.561v8.878a.75.75,0,0,1-1.219.586L15,9",
    transform: "translate(355 63)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44271",
    "data-name": "Path 44271",
    d: "M12,14H3a2.652,2.652,0,0,1-3-3V3A2.652,2.652,0,0,1,3,0h9a2.652,2.652,0,0,1,3,3v8a2.652,2.652,0,0,1-3,3",
    transform: "translate(355 63)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarVideo);
export default __webpack_public_path__ + "static/media/navbar_video.aa52a7b4b1d35d9f1ee047a381f4f4a1.svg";
export { ForwardRef as ReactComponent };